import styles from './style.module.scss';
import React, { useContext, useEffect, useState } from 'react';
import { AdminContext } from '../../context/AdminContext';
// import { AdminContext } from '../../../context/AdminContext';

export default function FileUploadVideo({
  handleChange,
  onButtonClick,
  handleDrag,
  handleDrop,
  dragActive,
  inputRef,
  allowedType,
  text,
  buttonStyle='nothing'
}) {
  const [type, setType] = useState([]);
  const { themeColor, videoType } = useContext(AdminContext);

  useEffect(() => {
    let allowed = [];
    videoType?.map((x) => {
      allowed = allowed.concat(x.mimeType);
    });
    setType(allowed);
  }, [videoType]);

  return (
    <div className={`flex flex-row justify-center align-center`}>
      <input
        ref={inputRef}
        type='file'
        id='input-file-upload'
        multiple={true}
        onChange={handleChange}
        className={`hidden`}
        accept={`${type}`}
      />
      <label
        id='label-file-upload'
        htmlFor='input-file-upload'
        className={dragActive ? styles.dragActive : ''}
      >
        <div>
          <button
            className={`${styles.uploadButton}  ${buttonStyle}`}
            onClick={onButtonClick}
          >
           {text}
          </button>
        </div>
      </label>
      {/* {dragActive && (
        <div
          className={styles.dragFileElement}
          onDragEnter={handleDrag}
          onDragLeave={handleDrag}
          onDragOver={handleDrag}
          onDrop={handleDrop}
        ></div>
      )} */}
    </div>
  );
}
